import type { HTMLAttributes, PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';

type Props = PropsWithChildren &
  HTMLAttributes<HTMLDivElement> & {
    snapAlignCenter?: boolean;
    boundariesPadding?: number;
  };

export const SnapCarouselItem = forwardRef<HTMLDivElement, Props>(
  (
    {
      snapAlignCenter = false,
      boundariesPadding,
      children,
      ...forwardingProps
    },
    forwardingRef
  ) => {
    return (
      <Item
        ref={forwardingRef}
        _snapAlignCenter={snapAlignCenter}
        _boundariesPadding={boundariesPadding}
        {...forwardingProps}
      >
        {children}
      </Item>
    );
  }
);

const Item = styled.div.attrs({
  className: createReadableClass({
    component: 'snap-carousel',
    element: 'item'
  })
})<{
  _snapAlignCenter: boolean;
  _boundariesPadding?: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  scroll-snap-align: ${({ _snapAlignCenter }) =>
    _snapAlignCenter ? 'center' : 'start'};

  ${({ _boundariesPadding }) =>
    _boundariesPadding &&
    css`
      transform: translateX(20px);
    `};
`;
